<script>
    import Package from './MediaPackage.vue'

    export default {
        components: {
            'package': Package
        },
        props: {
            step: {
                type: Number,
                default: null
            },
            selectedMedia: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
                uiStep: null, // null = lightbox closed, 1 = step 1, 2 = step 2, ...
                channels: null,
                selectedChannels: [],
                selectedMediaData: [],
                highlightedMediaIds: [],
                package: null,
                downloadStarted: false,
                skipStepTwo: false,
            }
        },
        computed: {
            previewMedia() {
                let previewMedia = this.selectedMediaData;

                // Used to show media immediatly after opening the lightbox, instead of waiting for ajax call
                if (!previewMedia.length) {
                    previewMedia = _.map(this.selectedMedia, function (id) {
                        return {id};
                    })
                }

                return _.slice(previewMedia, 0, 7);
            },
            selectedFormats: function () {
                if (!this.selectedChannels || !this.selectedChannels.length) {
                    return [];
                }

                let formats = [];

                _.each(this.selectedChannels, (channel) => {
                    formats = formats.concat(this.channels[channel]);
                });

                return _.uniq(formats);
            }
        },
        watch: {
            step: {
                immediate: true,
                handler(newValue) {
                    if (newValue !== null) {
                        this.loadData();

                        this.$nextTick(() => {
                            $(this.$refs.mediaDownloadPackageModal).on('hidden.bs.modal', () => {
                                this.close();
                            }).modal('show');
                        });

                        this.uiStep = newValue;
                    }
                },
            },
            uiStep(step) {
                if (this.skipStepTwo && step === 2) {
                    this.createPackage();
                }
            }
        },
        methods: {
            createPackage() {
                this.downloadStarted = true;
                axios.post(Scoop.baseUrl + '/mediaserver/components/create-media-download-package', {
                    channels: this.selectedChannels
                }).then(response => {
                    this.$emit('createPackageSuccessEvent');
                    this.package = response.data;
                    this.uiStep = 3;
                }).catch(error => {
                    this.$emit('createPackageFailedEvent', {error: error});
                    toastr.error(error.response.data.message, 'Could not create package', {timeOut: 5000});
                });
            },
            loadData() {
                axios.get(Scoop.baseUrl + '/mediaserver/components/create-media-download-package').then((response) => {
                    this.channels = response.data.channels;
                    this.selectedMediaData = response.data.selectedMediaData;
                    this.skipStepTwo = response.data.skipStepTwo;
                    this.selectedChannels = response.data.selectedChannels || [];

                    if (response.data.selectedChannels.length === 1) {
                        this.uiStep = 2;
                    }

                    this.$emit('loadDataSuccessEvent', {
                        channels: this.channels,
                        selectedMediaData: this.selectedMediaData,
                        step: this.step,
                    });
                }).catch((error) => {
                    toastr.error(error, 'Could not load data', {timeOut: 5000});
                    console.log(error);
                    this.$emit('loadDataFailedEvent', {
                        channels: this.channels,
                        selectedMediaData: this.selectedMediaData,
                        step: this.step,
                        error: error,
                    });
                });
            },
            close() {
                if (this.uiStep === 3) {
                    scoopOS.deselectAll('medias');
                }
                this.$emit('close');
            },
            mediaInChannel(channelName, formatName) {
                let mediaIds = [];

                if (!this.selectedMediaData) {
                    return mediaIds;
                }


                _.each(this.selectedMediaData, (media) => {
                    _.each(media.formats, (format) => {
                        if (format.format !== formatName) return;
                        if (-1 === _.indexOf(this.channels[channelName], formatName)) return; // Not defined for channel

                        mediaIds.push(format.media_id);
                    });
                });

                return _.uniq(mediaIds);
            },
            highlight(formatIds) {
                this.highlightedMediaIds = formatIds;
            },
            revertHighlight() {
                this.highlightedMediaIds = [];
            },
            isHighlighted(mediaId) {
                return -1 !== _.indexOf(this.highlightedMediaIds, mediaId);
            }
        },
    }
</script>
<template>
    <div ref="mediaDownloadPackageModal" class="modal inmodal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title" v-text="__('scoop-os.media.headline')"></h4>
                    <small class="font-bold">
                        <img
                                v-for="media in previewMedia"
                                :src="media.previewImageUrl"
                                width="30" height="30"
                                class="img-thumbnail img-md m-r-xs"
                                :class="{ 'panel-primary bg-danger': isHighlighted(media.id) }"
                        >
                        <!--style="border: 1px solid darkgray"-->
                        <span v-if="selectedMedia.length > previewMedia.length">
                            + {{ selectedMedia.length - previewMedia.length }}
                        </span>
                    </small>
                </div>
                <div class="modal-body">
                    <div v-if="uiStep === 1" class="row">
                        <template v-if="channels">
                            <div v-for="(formats, channelName) in channels" class="col-sm-4 m-t-sm">
                                <label>
                                    <input v-model="selectedChannels" type="checkbox" :value="channelName">
                                    {{ channelName }} ({{ formats.length }})
                                </label>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-lg-12 text-center">
                                <i class="fa fa-spinner fa-spin fa-5x fa-fw"></i>
                                <span class="sr-only">Loading...</span>
                            </div>
                        </template>
                    </div>
                    <div id="selectFormats" v-if="uiStep === 2" class="row">
                        <template v-if="!selectedFormats.length">
                            no formats selected
                        </template>
                        <template v-else>
                            <div class="col-lg-12">
                                <table class="table table-striped table-hover">
                                    <thead>
                                    <tr>
                                        <th>Channel</th>
                                        <th v-for="format in selectedFormats">
                                            <!--<i :title="format"-->
                                            <!--:data-original-title="format"-->
                                            <!--class="fa fa-file-o"-->
                                            <!--data-toggle="tooltip"-->
                                            <!--data-placement="top"-->
                                            <!--&gt;</i>-->
                                            <span v-text="format"
                                                  :style="selectedFormats.length > 5 ? 'writing-mode: vertical-lr; text-orientation: mixed' : ''"></span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="channelName in selectedChannels">
                                        <td v-text="channelName"></td>
                                        <td v-for="formatName in selectedFormats">
                                            <a
                                                    @mouseover="highlight(mediaInChannel(channelName, formatName))"
                                                    @mouseleave="revertHighlight"
                                                    :title="formatName + ' / ' + channelName"
                                                    v-text="mediaInChannel(channelName, formatName).length">
                                            </a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </div>
                    <div id="package" v-if="uiStep === 3" class="row">
                        <template v-if="package">
                            <media-package v-model="package" :opened-within-modal="true"></media-package>
                        </template>
                        <template v-else>
                            <div class="col-lg-12 text-center">
                                <i class="fa fa-spinner fa-spin fa-5x fa-fw"></i>
                                <span class="sr-only">Loading...</span>
                            </div>
                        </template>
                    </div>
                </div>
                <div v-if="uiStep === 1" class="modal-footer">
                    <div class="pull-left">
                        <button type="button" class="btn btn-white" data-dismiss="modal"
                                v-text="__('scoop-os.common.close')"></button>
                    </div>
                    <button v-if="selectedChannels.length" @click="uiStep = 2" type="button" class="btn btn-primary">
                        Next
                    </button>
                </div>
                <div v-if="uiStep === 2" class="modal-footer">
                    <div class="pull-left">
                        <button @click="uiStep = 1" type="button" class="btn btn-white">
                            <i class="fa fa-angle-left" aria-hidden="true"></i>
                            Back
                        </button>
                        <button type="button" class="btn btn-white" data-dismiss="modal">Close</button>
                    </div>
                    <button v-if="selectedChannels.length && !downloadStarted" @click="createPackage" type="button"
                            class="btn btn-primary">
                        Create Package
                    </button>
                    <button v-if="downloadStarted" class="btn btn-primary" disabled>
                        <i class="fa fa-spinner fa-spin fa-fw"></i>
                        Preparing Download
                    </button>
                </div>
                <div v-if="uiStep === 3" class="modal-footer">
                    <div class="pull-left">
                        <a :href="baseUrl + '/mediaserver/packages'"
                           v-text="__('scoop-os.packages.link.alldownloads')"></a>
                    </div>
                    <button type="button" class="btn btn-white" data-dismiss="modal"
                            v-text="__('scoop-os.common.close')"></button>
                </div>
            </div>
        </div>
    </div>
</template>
